/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Button, Modal, Table } from "semantic-ui-react";
import { selectCurrentUserApiToken } from "../../slices/currentUser/currentUserSlice";
import { selectAllTopSections, selectTopSectionById, selectTopSectionsStatus, topSectionUpdated } from "../../slices/topSections/topSectionsSlice";
import { selectEditMode } from "../../slices/editMode/editModeSlice";
import { selectComparativeEvidenceMap } from "../../slices/comparativeEvidenceMap/comparativeEvidenceMapSlice";
import { fetchOutcomeVariables, outcomeVariableAdded, outcomeVariableUpdated, selectAllOutcomeVariables, selectOutcomeVariableById, selectOutcomeVariablesStatus } from "../../slices/outcomeVariables/outcomeVariablesSlice";
import { selectAllResources } from "../../slices/resourceCollection/resourceCollectionSlice";
import { globalLoadingOff, globalLoadingOn } from "../../slices/globalLoading/globalLoadingSlice";
import { loadSummaryOfFindings, selectAllSummaryOfFindings, selectSummaryOfFindingsByTargetId, selectSummaryOfFindingsStatus, summaryOfFindingsAdded, summaryOfFindingsUpdated } from "../../slices/summaryOfFindings/summaryOfFindingsSlice";
import StringEntry from "../../datatypeComponents/StringEntry";
import ReferenceEntry from "../../datatypeComponents/ReferenceEntry";
import ChangeBaselineRiskEstimates from "./ChangeBaselineRiskEstimates";
import GenerateNetEffectReport from "./GenerateNetEffectReport";
import getIdFromReference from "../../functions/getIdFromReference";
import jsonEquals from "../../functions/jsonEquals";
import { generateSectionTextForAssertion, generateSectionTextForCalculatedInterventionResult, generateSectionTextForCertaintyOfEvidence, generateSectionTextForEffectEstimate, generateSectionTextForPercentage, generateSectionTextForRelativeImportance, generateSectionTextForSampleSize } from "../compositionResourceFunctions/summaryOfFindingsFunctions";
import { extractControlEventRate, extractRiskDifferenceAndInterventionEventRate } from "./SummaryOfNetEffectTable";
import { baselineRiskAdded, baselineRiskUpdated, fetchBaselineRisk, selectAllBaselineRisks, selectBaselineRiskById, selectBaselineRiskStatus } from "../../slices/baselineRisk/baselineRiskSlice";
import addFoisFromFlisInTargetResources from "../compositionResourceFunctions/addFoisFromFlisInTargetResources";
import { simpleDisplayStringFromFHIRCodeableConcept } from "../../datatypeComponents/CodeableConceptEntry";
import NarrativeEntry, { clearDivWrapper, DisplayFromFHIRXhtml } from "../../datatypeComponents/NarrativeEntry";
import { emptyReasonNotStarted } from "../../dictionaries/CodeSystemLookup";
import { createSimpleEvidenceDisplay } from "../compositionResourceFunctions/createEvidenceDisplay";

const recalculateSummaryOfFindingsFromResourceChanges = (summaryOfFindingsSection,
    controlEvidenceResourceState,
    comparativeEvidenceResourceState, outcomeVariableResourceState,
    interventionEvidenceResourceState, certaintyOfEvidenceResourceState,
    itemIndex, dispatch, setGeneratedNarrativeState, compositionId,
    evidenceReferencesState) => {

    console.log("recalculateSummaryOfFindingsFromResourceChanges")
    let initialSummaryOfFindingsSection = JSON.parse(JSON.stringify(summaryOfFindingsSection));
    let revisedSummaryOfFindingsSection = JSON.parse(JSON.stringify(summaryOfFindingsSection));

    let controlEventRate = NaN;
    let controlEventRateDisplay = "[Not a proportion.]";
    let riskDifference = NaN;
    let riskDifferenceDisplay = '[Not a difference in proportions.]';
    let interventionEventRate = NaN;
    let interventionEventRateDisplay = '[Not a proportion.]';
    let riskDifferenceLowValue = NaN;
    let riskDifferenceLowValueDisplay = 'No lower bound';
    let riskDifferenceHighValue = NaN;
    let riskDifferenceHighValueDisplay = 'No upper bound';
    let controlEvidence;
    let comparativeEvidence;
    let cellDisplay = "Edit Resource Content to add initial statistic.";
    let observedInterventionEventRate = NaN;
    let observedInterventionEventRateDisplay = "[Not a proportion.]";
    let interventionEvidence;
    if (controlEvidenceResourceState) {
        controlEvidence = controlEvidenceResourceState;
        controlEventRateDisplay = createSimpleEvidenceDisplay(controlEvidenceResourceState);
    }
    if (comparativeEvidenceResourceState) {
        comparativeEvidence = comparativeEvidenceResourceState;
        riskDifferenceDisplay = createSimpleEvidenceDisplay(comparativeEvidenceResourceState);
    }
    let [returnA, returnB] = extractControlEventRate(controlEvidence, controlEventRate, controlEventRateDisplay);
    controlEventRate = returnA;
    controlEventRateDisplay = returnB;
    if (itemIndex === 2 && controlEvidence) {
        cellDisplay = controlEventRateDisplay;
    }
    if (interventionEvidenceResourceState) {
        interventionEvidence = interventionEvidenceResourceState;
    }
    let [returnAi, returnBi] = extractControlEventRate(interventionEvidence, observedInterventionEventRate, observedInterventionEventRateDisplay);
    observedInterventionEventRate = returnAi;
    observedInterventionEventRateDisplay = returnBi;

    let [riskDifferenceA, riskDifferenceDisplayA, interventionEventRateA, interventionEventRateDisplayA,
        riskDifferenceLowValueA, riskDifferenceLowValueDisplayA, riskDifferenceHighValueA,
        riskDifferenceHighValueDisplayA] = extractRiskDifferenceAndInterventionEventRate(controlEventRate, riskDifference, riskDifferenceDisplay, interventionEventRate, interventionEventRateDisplay,
            riskDifferenceLowValue, riskDifferenceLowValueDisplay, riskDifferenceHighValue,
            riskDifferenceHighValueDisplay, comparativeEvidence, dispatch);
    riskDifference = riskDifferenceA;
    riskDifferenceDisplay = riskDifferenceDisplayA;
    interventionEventRate = interventionEventRateA;
    interventionEventRateDisplay = interventionEventRateDisplayA;
    riskDifferenceLowValue = riskDifferenceLowValueA;
    riskDifferenceLowValueDisplay = riskDifferenceLowValueDisplayA;
    riskDifferenceHighValue = riskDifferenceHighValueA;
    riskDifferenceHighValueDisplay = riskDifferenceHighValueDisplayA;

    if (itemIndex === 3 && interventionEvidence) {
        cellDisplay = observedInterventionEventRateDisplay;
    }
    if (itemIndex === 4 && controlEvidence && comparativeEvidence) {
        cellDisplay = interventionEventRateDisplay;
    };
    if (itemIndex === 5 && comparativeEvidence) {
        cellDisplay = riskDifferenceDisplay;
    }
    if (itemIndex === 0 && outcomeVariableResourceState) {
        cellDisplay = outcomeVariableResourceState.shortTitle || outcomeVariableResourceState.title;
    }
    if (itemIndex === 1 && comparativeEvidence) {
        cellDisplay = "[No statistic found.]";
        if (comparativeEvidence.statistic?.length > 0) {
            for (const statistic of comparativeEvidence.statistic) {
                let resultDisplayList = [];
                if (statistic.sampleSize) {
                    if (statistic.sampleSize.numberOfStudies !== undefined && statistic.sampleSize.numberOfStudies !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfStudies + ' studies');
                    }
                    if (statistic.sampleSize.numberOfParticipants !== undefined && statistic.sampleSize.numberOfParticipants !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfParticipants + ' participants');
                    }
                    if (statistic.sampleSize.numberAnalyzed !== undefined && statistic.sampleSize.numberAnalyzed !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberAnalyzed + ' analyzed');
                    }
                    if (statistic.sampleSize.knownDataCount !== undefined && statistic.sampleSize.knownDataCount !== "") {
                        resultDisplayList.push(statistic.sampleSize.knownDataCount + ' without missing data');
                    }
                }
                if ((statistic.numberAffected !== undefined && statistic.numberAffected !== "") || (statistic.numberOfEvents !== undefined && statistic.numberOfEvents !== "")) {
                    let abc = statistic.numberAffected !== undefined ? statistic.numberAffected : statistic.numberOfEvents;
                    resultDisplayList.push(abc + ' events');
                }
                if (resultDisplayList.length) {
                    cellDisplay = resultDisplayList.join(', ');
                    break;
                } else {
                    cellDisplay = "[No sample size data.]";
                }
            }
        }
    }
    if (itemIndex === 7 && comparativeEvidence) {
        cellDisplay = comparativeEvidence.assertion || "[No assertion made.]";
    }
    if (itemIndex === 6) {
        cellDisplay = "";
        if (certaintyOfEvidenceResourceState?.text?.div) {
            cellDisplay = clearDivWrapper(certaintyOfEvidenceResourceState.text.div);
        } else if (comparativeEvidence?.certainty?.length > 0) {
            if (comparativeEvidence.certainty[0]) {
                if (comparativeEvidence.certainty[0].rating) {
                    cellDisplay = simpleDisplayStringFromFHIRCodeableConcept(comparativeEvidence.certainty[0].rating);
                }
                if (comparativeEvidence.certainty[0].description) {
                    if (cellDisplay) {
                        cellDisplay += " -- ";
                    }
                    cellDisplay += comparativeEvidence.certainty[0].description;
                }
            }
            if (!cellDisplay) {
                cellDisplay = "[Certainty not specified.]";
            }
        } else {
            cellDisplay = "[Certainty not specified.]";
        }
    }
    if (cellDisplay) {
        setGeneratedNarrativeState({
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + cellDisplay + "</p></div>"
        });
    }

    revisedSummaryOfFindingsSection.section[0].entry = [evidenceReferencesState.outcomeVariableReference];
    revisedSummaryOfFindingsSection.section[1].entry = [evidenceReferencesState.comparativeEvidenceReference];
    revisedSummaryOfFindingsSection.section[2].entry = [evidenceReferencesState.controlEvidenceReference];
    revisedSummaryOfFindingsSection.section[3].entry = [evidenceReferencesState.interventionEvidenceReference];
    revisedSummaryOfFindingsSection.section[5].entry = [evidenceReferencesState.comparativeEvidenceReference];

    revisedSummaryOfFindingsSection.section[4].entry = [
        evidenceReferencesState.controlEvidenceReference,
        evidenceReferencesState.comparativeEvidenceReference
    ];
    if (evidenceReferencesState.certaintyOfEvidenceReference) {
        revisedSummaryOfFindingsSection.section[6].entry = [evidenceReferencesState.certaintyOfEvidenceReference];
    } else if (evidenceReferencesState.comparativeEvidenceReference) {
        revisedSummaryOfFindingsSection.section[6].entry = [evidenceReferencesState.comparativeEvidenceReference];
    }
    revisedSummaryOfFindingsSection.section[7].entry = [evidenceReferencesState.comparativeEvidenceReference];

    if (JSON.stringify(initialSummaryOfFindingsSection) !==
        JSON.stringify(revisedSummaryOfFindingsSection)) {
        revisedSummaryOfFindingsSection.itemChanged = true;
        dispatch(summaryOfFindingsUpdated(revisedSummaryOfFindingsSection));
    }
};

const generateTableRowContent = async (revisedRow, resourceDictionary) => {
    let sourceReferences = {
        outcomeDefinition: "", interventionOnlyEvidence: "", comparatorOnlyEvidence: "",
        comparativeEvidence: "", outcomeImportance: "", certaintyOfEvidence: ""
    };
    for (let section of revisedRow.section) {
        let sectionCode;
        if (section?.code) {
            sectionCode = section.code.text || section.code.coding?.[0]?.code;
        }
        if (sectionCode === "outcome-measure" || sectionCode === "EvidenceVariable-outcome") {
            if (section.entry?.length > 0) {
                sourceReferences.outcomeDefinition = section.entry[0];
            }
        }
        if (sectionCode === "result-with-comparator-alone" || sectionCode === "Control-group-alone-Evidence" ||
            sectionCode === "evidence-with-comparator-alone") {
            if (section.entry?.length > 0) {
                sourceReferences.comparatorOnlyEvidence = section.entry[0];
            }
        }
        if (sectionCode === "result-with-intervention-alone" || sectionCode === "Intervention-group-alone-Evidence" ||
            sectionCode === "evidence-with-intervention-alone") {
            if (section.entry?.length > 0) {
                sourceReferences.interventionOnlyEvidence = section.entry[0];
            }
        }
        if (sectionCode === "result-with-intervention-vs-comparator" || sectionCode === "Intervention-vs-Control-Evidence" ||
            sectionCode === "evidence-with-intervention-vs-comparator") {
            if (section.entry?.length > 0) {
                sourceReferences.comparativeEvidence = section.entry[0];
            }
        }
        if (sectionCode === "relative-importance") {
            if (section.entry?.length > 0) {
                sourceReferences.outcomeImportance = section.entry[0];
            }
        }
        if (sectionCode === "certainty-of-evidence") {
            if (section.entry?.length > 0 && section.entry[0].type === "ArtifactAssessment") {
                sourceReferences.certaintyOfEvidence = section.entry[0];
            }
        }
    }

    let newRowSections = revisedRow.section;
    if (Array.isArray(newRowSections) && newRowSections.length > 0) {
        let outcomeDefinitionJson;
        let comparatorOnlyEvidenceJson;
        let interventionOnlyEvidenceJson;
        let comparativeEvidenceJson;
        let outcomeImportanceJson;
        let certaintyOfEvidenceJson;
        if (sourceReferences.outcomeDefinition) {
            let outcomeDefinitionFoi = getIdFromReference(sourceReferences.outcomeDefinition);
            if (outcomeDefinitionFoi && resourceDictionary[outcomeDefinitionFoi]) {
                outcomeDefinitionJson = resourceDictionary[outcomeDefinitionFoi];
            }
        }
        if (!outcomeDefinitionJson) {
            let outcomeDefinitionFoi = getIdFromReference(revisedRow.focus);
            if (outcomeDefinitionFoi && resourceDictionary[outcomeDefinitionFoi]) {
                outcomeDefinitionJson = resourceDictionary[outcomeDefinitionFoi];
            }
        }
        if (sourceReferences.comparatorOnlyEvidence) {
            let comparatorOnlyEvidenceFoi = getIdFromReference(sourceReferences.comparatorOnlyEvidence);
            if (comparatorOnlyEvidenceFoi && resourceDictionary[comparatorOnlyEvidenceFoi]) {
                comparatorOnlyEvidenceJson = resourceDictionary[comparatorOnlyEvidenceFoi];
            }
        }
        if (sourceReferences.interventionOnlyEvidence) {
            let interventionOnlyEvidenceFoi = getIdFromReference(sourceReferences.interventionOnlyEvidence);
            if (interventionOnlyEvidenceFoi && resourceDictionary[interventionOnlyEvidenceFoi]) {
                interventionOnlyEvidenceJson = resourceDictionary[interventionOnlyEvidenceFoi];
            }
        }
        if (sourceReferences.comparativeEvidence) {
            let comparativeEvidenceFoi = getIdFromReference(sourceReferences.comparativeEvidence);
            if (comparativeEvidenceFoi && resourceDictionary[comparativeEvidenceFoi]) {
                comparativeEvidenceJson = resourceDictionary[comparativeEvidenceFoi];
            }
        }
        if (sourceReferences.outcomeImportance) {
            let outcomeImportanceFoi = getIdFromReference(sourceReferences.outcomeImportance);
            if (outcomeImportanceFoi && resourceDictionary[outcomeImportanceFoi]) {
                outcomeImportanceJson = resourceDictionary[outcomeImportanceFoi];
            }
        }
        if (sourceReferences.certaintyOfEvidence) {
            let certaintyOfEvidenceFoi = getIdFromReference(sourceReferences.certaintyOfEvidence);
            if (certaintyOfEvidenceFoi && resourceDictionary[certaintyOfEvidenceFoi]) {
                certaintyOfEvidenceJson = resourceDictionary[certaintyOfEvidenceFoi];
            }
        }
        for (let section of newRowSections) {
            if (section.code?.coding && section.code.coding[0].code) {
                switch (section.code.coding[0].code) {
                    case "outcome-measure":
                        if (outcomeDefinitionJson) {
                            section.entry = [sourceReferences.outcomeDefinition];
                            let outcomeName = outcomeDefinitionJson.shortTitle ||
                                outcomeDefinitionJson.title || outcomeDefinitionJson.name ||
                                sourceReferences.outcomeDefinition.display || '[No title found.]';
                            section.text = {
                                "status": "generated",
                                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" +
                                    outcomeName.replace('OutcomeDefinition: ', '')
                                        .replace("VariableDefinition: ", "")
                                        .replace("DIO: ", "")
                                        .replace("DichotomousIntendedOutcome: ", "") +
                                    "</p></div>"
                            };
                        }
                        break;
                    case "EvidenceVariable-outcome":
                        if (outcomeDefinitionJson) {
                            section.entry = [sourceReferences.outcomeDefinition];
                            let outcomeName = outcomeDefinitionJson.shortTitle ||
                                outcomeDefinitionJson.title || outcomeDefinitionJson.name || '[No title found.]';
                            section.text = {
                                "status": "generated",
                                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" +
                                    outcomeName.replace('OutcomeDefinition: ', '')
                                        .replace("VariableDefinition: ", "")
                                        .replace("DIO: ", "")
                                        .replace("DichotomousIntendedOutcome: ", "") +
                                    "</p></div>"
                            };
                        }
                        break;
                    case "sample-size":
                        generateSectionTextForSampleSize(section, comparativeEvidenceJson, sourceReferences);
                        break;
                    case "SampleSize":
                        generateSectionTextForSampleSize(section, comparativeEvidenceJson, sourceReferences);
                        break;
                    case "result-with-comparator-alone":
                        if (comparatorOnlyEvidenceJson) {
                            section.entry = [sourceReferences.comparatorOnlyEvidence];
                            generateSectionTextForPercentage(section, comparatorOnlyEvidenceJson.statistic);
                        }
                        break;
                    case "evidence-with-comparator-alone":
                        if (comparatorOnlyEvidenceJson) {
                            section.entry = [sourceReferences.comparatorOnlyEvidence];
                            generateSectionTextForPercentage(section, comparatorOnlyEvidenceJson.statistic);
                        }
                        break;
                    case "Control-group-alone-Evidence":
                        if (comparatorOnlyEvidenceJson) {
                            section.entry = [sourceReferences.comparatorOnlyEvidence];
                            generateSectionTextForPercentage(section, comparatorOnlyEvidenceJson.statistic);
                        }
                        break;
                    case "result-with-intervention-alone":
                        if (interventionOnlyEvidenceJson) {
                            section.entry = [sourceReferences.interventionOnlyEvidence];
                            generateSectionTextForPercentage(section, interventionOnlyEvidenceJson.statistic);
                        }
                        break;
                    case "evidence-with-intervention-alone":
                        if (interventionOnlyEvidenceJson) {
                            section.entry = [sourceReferences.interventionOnlyEvidence];
                            generateSectionTextForPercentage(section, interventionOnlyEvidenceJson.statistic);
                        }
                        break;
                    case "Intervention-group-alone-Evidence":
                        if (interventionOnlyEvidenceJson) {
                            section.entry = [sourceReferences.interventionOnlyEvidence];
                            generateSectionTextForPercentage(section, interventionOnlyEvidenceJson.statistic);
                        }
                        break;
                    case "result-with-intervention-vs-comparator":
                        generateSectionTextForEffectEstimate(section, comparativeEvidenceJson, sourceReferences);
                        break;
                    case "Intervention-vs-Control-Evidence":
                        generateSectionTextForEffectEstimate(section, comparativeEvidenceJson, sourceReferences);
                        break;
                    case "certainty-of-evidence":
                        if (certaintyOfEvidenceJson) {
                            section.entry = [sourceReferences.certaintyOfEvidence];
                            if (certaintyOfEvidenceJson?.text?.div) {
                                let certaintyDisplay = clearDivWrapper(certaintyOfEvidenceJson.text.div);
                                section.text = {
                                    "status": "generated",
                                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certaintyDisplay + "</p></div>"
                                };
                            } else {
                                section.text = {
                                    "status": "generated",
                                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[Certainty not specified with Narrative.]</p></div>"
                                };
                            }
                        } else {
                            generateSectionTextForCertaintyOfEvidence(section, comparativeEvidenceJson, sourceReferences);
                        }
                        break;
                    case "Certainty-of-Evidence":
                        if (certaintyOfEvidenceJson) {
                            section.entry = [sourceReferences.certaintyOfEvidence];
                            if (certaintyOfEvidenceJson?.text?.div) {
                                let certaintyDisplay = clearDivWrapper(certaintyOfEvidenceJson.text.div);
                                section.text = {
                                    "status": "generated",
                                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certaintyDisplay + "</p></div>"
                                };
                            } else {
                                section.text = {
                                    "status": "generated",
                                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[Certainty not specified with Narrative.]</p></div>"
                                };
                            }
                        } else {
                            generateSectionTextForCertaintyOfEvidence(section, comparativeEvidenceJson, sourceReferences);
                        }
                        break;
                    case "assertion":
                        generateSectionTextForAssertion(section, comparativeEvidenceJson, sourceReferences);
                        break;
                    case "Assertion":
                        generateSectionTextForAssertion(section, comparativeEvidenceJson, sourceReferences);
                        break;
                    case "result-with-intervention-alone-calculated":
                        generateSectionTextForCalculatedInterventionResult(section, comparativeEvidenceJson,
                            comparatorOnlyEvidenceJson, sourceReferences);
                        break;
                    case "relative-importance":
                        generateSectionTextForRelativeImportance(section, outcomeImportanceJson, sourceReferences);
                        break;
                    default:
                        console.log("UNRECOGNIZED section code: " + section.code.coding[0].code);
                }
            } else if (section.code?.text) {
                if (section.code.text === "calculated value derived from the control group and effect estimate") {
                    generateSectionTextForCalculatedInterventionResult(section, comparativeEvidenceJson,
                        comparatorOnlyEvidenceJson, sourceReferences);
                } else if (section.code.text === "relative importance of outcome") {
                    generateSectionTextForRelativeImportance(section, outcomeImportanceJson, sourceReferences);
                } else {
                    console.log("UNRECOGNIZED section code text: " + section.code.text);
                }
            }
        }
        return revisedRow;
    } else {
        console.log('newRowSections is not an array.')
        console.log(newRowSections);
    }
};

const regenerateTableRow = async (row, combinedDictionary, dispatch) => {
    let revisedRow = JSON.parse(JSON.stringify(row));
    revisedRow = await generateTableRowContent(revisedRow, combinedDictionary);
    revisedRow.itemChanged = true;
    dispatch(summaryOfFindingsUpdated(revisedRow));
}

const submitNewRowChange = (addTableRowModalState, newRowSectionsState,
    dispatch, setOpenAddTableRowModalState) => {
    let tableRowSectionCode = {
        "coding": [
            {
                "system": "https://fevir.net/resources/CodeSystem/179423",
                "code": "summary-of-findings-entry-for-a-single-outcome",
                "display": "Summary of findings entry for a single outcome"
            }
        ]
    };
    if (addTableRowModalState.newRowTitle) {
        let newRow = {
            "title": addTableRowModalState.newRowTitle,
            "code": tableRowSectionCode,
            "focus": addTableRowModalState.newRowFocus || { "display": "[No data]" },
            "section": newRowSectionsState.newRowSections
        };
        newRow.id = getIdFromReference(newRow.focus);
        newRow.itemChanged = true;
        dispatch(summaryOfFindingsAdded(newRow));
        setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
    }
}

const generateNewTableRow = (sourceReferencesState, setNewRowSectionsState,
    compositionId, combinedDictionary, dispatch) => {
    let newRowSections = [
        {
            "title": "Outcome",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "outcome-measure",
                        "display": "Outcome Measure"
                    }
                ]
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        },
        {
            "title": "Sample Size",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "sample-size",
                        "display": "Sample Size"
                    }
                ]
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        },
        {
            "title": "Result Without Treatment",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "result-with-comparator-alone",
                        "display": "Result with comparator alone"
                    }
                ]
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        },
        {
            "title": "Result With Treatment--Observed",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "result-with-intervention-alone",
                        "display": "Result with intervention alone"
                    }
                ]
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        },
        {
            "title": "Result With Treatment--Derived",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "result-with-intervention-alone-calculated",
                        "display": "Result with intervention alone (calculated)"
                    }
                ],
                "text": "result with intervention with calculated value derived from the control group and effect estimate"
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        },
        {
            "title": "Effect Estimate",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "result-with-intervention-vs-comparator",
                        "display": "Result with intervention vs. comparator"
                    }
                ]
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        },
        {
            "title": "Certainty of Evidence",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "certainty-of-evidence",
                        "display": "Certainty of Evidence"
                    }
                ]
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        },
        {
            "title": "Assertion",
            "code": {
                "coding": [
                    {
                        "system": "https://fevir.net/resources/CodeSystem/179423",
                        "code": "assertion",
                        "display": "Assertion"
                    }
                ]
            },
            "text": {
                "status": "empty",
                "div": '<div xmlns="http://www.w3.org/1999/xhtml"><p>[No data.]</p></div>'
            },
            "entry": [],
            "emptyReason": emptyReasonNotStarted
        }
    ];
    if (sourceReferencesState.outcomeDefinition) {
        newRowSections[0].entry.push(sourceReferencesState.outcomeDefinition);
        newRowSections[0].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + sourceReferencesState.outcomeDefinition.display + "</p></div>"
        };
        delete newRowSections[0].emptyReason;
    }

    let controlEventRate = NaN;
    let controlEventRateDisplay = "[Not a proportion.]";
    if (sourceReferencesState.comparatorOnlyEvidence) {
        newRowSections[2].entry.push(sourceReferencesState.comparatorOnlyEvidence);
        delete newRowSections[2].emptyReason;
        newRowSections[4].entry.push(sourceReferencesState.comparatorOnlyEvidence);
        newRowSections[4].entry.push(sourceReferencesState.comparativeEvidence);
        delete newRowSections[4].emptyReason;
        let baselineRiskFoi = getIdFromReference(sourceReferencesState.comparatorOnlyEvidence);
        let baselineRiskEvidence = combinedDictionary[baselineRiskFoi];
        let [returnA, returnB] = extractControlEventRate(baselineRiskEvidence, controlEventRate, controlEventRateDisplay);
        controlEventRate = returnA;
        controlEventRateDisplay = returnB;
        newRowSections[2].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + controlEventRateDisplay + "</p></div>"
        };
    }
    let riskDifference = NaN;
    let riskDifferenceDisplay = '[Not a difference in proportions.]';
    let interventionEventRate = NaN;
    let interventionEventRateDisplay = '[Not a proportion.]';
    let riskDifferenceLowValue = NaN;
    let riskDifferenceLowValueDisplay = 'No lower bound';
    let riskDifferenceHighValue = NaN;
    let riskDifferenceHighValueDisplay = 'No upper bound';
    let comparativeEvidence;
    if (sourceReferencesState.comparativeEvidence) {
        newRowSections[5].entry.push(sourceReferencesState.comparativeEvidence);
        delete newRowSections[5].emptyReason;
        newRowSections[1].entry.push(sourceReferencesState.comparativeEvidence);
        delete newRowSections[1].emptyReason;
        newRowSections[6].entry.push(sourceReferencesState.comparativeEvidence);
        delete newRowSections[6].emptyReason;
        newRowSections[7].entry.push(sourceReferencesState.comparativeEvidence);
        delete newRowSections[7].emptyReason;
        let effectEstimateFoi = getIdFromReference(sourceReferencesState.comparativeEvidence);
        comparativeEvidence = combinedDictionary[effectEstimateFoi];

        let [riskDifferenceA, riskDifferenceDisplayA, interventionEventRateA, interventionEventRateDisplayA,
            riskDifferenceLowValueA, riskDifferenceLowValueDisplayA, riskDifferenceHighValueA,
            riskDifferenceHighValueDisplayA] = extractRiskDifferenceAndInterventionEventRate(controlEventRate, riskDifference, riskDifferenceDisplay, interventionEventRate, interventionEventRateDisplay,
                riskDifferenceLowValue, riskDifferenceLowValueDisplay, riskDifferenceHighValue,
                riskDifferenceHighValueDisplay, comparativeEvidence, dispatch);
        riskDifference = riskDifferenceA;
        riskDifferenceDisplay = riskDifferenceDisplayA;
        interventionEventRate = interventionEventRateA;
        interventionEventRateDisplay = interventionEventRateDisplayA;
        riskDifferenceLowValue = riskDifferenceLowValueA;
        riskDifferenceLowValueDisplay = riskDifferenceLowValueDisplayA;
        riskDifferenceHighValue = riskDifferenceHighValueA;
        riskDifferenceHighValueDisplay = riskDifferenceHighValueDisplayA;

        newRowSections[4].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + interventionEventRateDisplay + "</p></div>"
        };
        newRowSections[5].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + riskDifferenceDisplay + "</p></div>"
        };
        let sampleSizeDisplay = "[No statistic found.]";
        if (comparativeEvidence?.statistic?.length > 0) {
            for (const statistic of comparativeEvidence.statistic) {
                let resultDisplayList = [];
                if (statistic.sampleSize) {
                    if (statistic.sampleSize.numberOfStudies !== undefined && statistic.sampleSize.numberOfStudies !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfStudies + ' studies');
                    }
                    if (statistic.sampleSize.numberOfParticipants !== undefined && statistic.sampleSize.numberOfParticipants !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberOfParticipants + ' participants');
                    }
                    if (statistic.sampleSize.numberAnalyzed !== undefined && statistic.sampleSize.numberAnalyzed !== "") {
                        resultDisplayList.push(statistic.sampleSize.numberAnalyzed + ' analyzed');
                    }
                    if (statistic.sampleSize.knownDataCount !== undefined && statistic.sampleSize.knownDataCount !== "") {
                        resultDisplayList.push(statistic.sampleSize.knownDataCount + ' without missing data');
                    }
                }
                if ((statistic.numberAffected !== undefined && statistic.numberAffected !== "") || (statistic.numberOfEvents !== undefined && statistic.numberOfEvents !== "")) {
                    let abc = statistic.numberAffected !== undefined ? statistic.numberAffected : statistic.numberOfEvents;
                    resultDisplayList.push(abc + ' events');
                }
                if (resultDisplayList.length) {
                    sampleSizeDisplay = resultDisplayList.join(', ');
                    break;
                } else {
                    sampleSizeDisplay = "[No sample size data.]";
                }
            }
        }
        let certaintyDisplay = "";
        if (comparativeEvidence?.certainty?.[0]) {
            if (comparativeEvidence.certainty[0].rating) {
                certaintyDisplay = simpleDisplayStringFromFHIRCodeableConcept(comparativeEvidence.certainty[0].rating);
            }
            if (comparativeEvidence.certainty[0].description) {
                if (certaintyDisplay) {
                    certaintyDisplay += " -- ";
                }
                certaintyDisplay += comparativeEvidence.certainty[0].description;
            }
        }
        if (!certaintyDisplay) {
            certaintyDisplay = "[Certainty not specified.]";
        }
        let assertionDisplay = comparativeEvidence?.assertion || "[No assertion made.]";
        newRowSections[1].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + sampleSizeDisplay + "</p></div>"
        };
        newRowSections[6].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certaintyDisplay + "</p></div>"
        };
        newRowSections[7].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + assertionDisplay + "</p></div>"
        };

    }
    let observedInterventionEventRate = NaN;
    let observedInterventionEventRateDisplay = "[Not a proportion.]";
    if (sourceReferencesState.interventionOnlyEvidence) {
        newRowSections[3].entry.push(sourceReferencesState.interventionOnlyEvidence);
        delete newRowSections[3].emptyReason;

        let interventionEvidenceFoi = getIdFromReference(sourceReferencesState.interventionOnlyEvidence);
        let interventionRiskEvidence = combinedDictionary[interventionEvidenceFoi];
        let [returnA, returnB] = extractControlEventRate(interventionRiskEvidence, observedInterventionEventRate, observedInterventionEventRateDisplay);
        observedInterventionEventRate = returnA;
        observedInterventionEventRateDisplay = returnB;
        newRowSections[3].text = {
            "status": "generated",
            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + observedInterventionEventRateDisplay + "</p></div>"
        };
    }
    if (sourceReferencesState.certaintyOfEvidence) {
        newRowSections[6].entry = [sourceReferencesState.certaintyOfEvidence];
        if (newRowSections[6].emptyReason) {
            delete newRowSections[6].emptyReason;
        }
        let certaintyOfEvidenceFoi = getIdFromReference(sourceReferencesState.certaintyOfEvidence);
        let certaintyOfEvidence = combinedDictionary[certaintyOfEvidenceFoi];
        if (certaintyOfEvidence?.text?.div) {
            let certaintyDisplay = clearDivWrapper(certaintyOfEvidence.text.div);
            newRowSections[6].text = {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certaintyDisplay + "</p></div>"
            };
        } else {
            newRowSections[6].text = {
                "status": "generated",
                "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[Certainty not specified with Narrative.]</p></div>"
            };
        }
    }
    setNewRowSectionsState({
        "newRowSections": newRowSections,
        "tableRowContentGenerated": true
    });
}

const AddTableRowModal = ({ setTriggerReloadState, setOpenAddTableRowModalState, containedResourceDictionary = {} }) => {

    const dispatch = useDispatch();
    const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);
    const combinedDictionary = comparativeEvidenceMap.combinedDictionary;
    const compositionId = comparativeEvidenceMap.compositionId;
    const outcomeVariables = useSelector((state) => selectAllOutcomeVariables(state));
    const outcomeDictionary = {};
    for (let key in outcomeVariables) {
        outcomeDictionary[outcomeVariables[key].id] = outcomeVariables[key];
    }

    let populationClassifications = [];
    let picClassifications = [];
    if (comparativeEvidenceMap.picoClassifiers) {
        if (comparativeEvidenceMap.picoClassifiers.populationArray?.length > 0) {
            populationClassifications = [{
                "type": {
                    "coding": [
                        {
                            "code": "population",
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "display": "Population"
                        }
                    ]
                },
                "classifier": comparativeEvidenceMap.picoClassifiers.populationArray
            }];
            picClassifications.push({
                "type": {
                    "coding": [
                        {
                            "code": "population",
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "display": "Population"
                        }
                    ]
                },
                "classifier": comparativeEvidenceMap.picoClassifiers.populationArray
            });
        }
        if (comparativeEvidenceMap.picoClassifiers.interventionArray?.length > 0) {
            picClassifications.push({
                "type": {
                    "coding": [
                        {
                            "code": "intervention",
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "display": "Intervention"
                        }
                    ]
                },
                "classifier": comparativeEvidenceMap.picoClassifiers.interventionArray
            });
        }
        if (comparativeEvidenceMap.picoClassifiers.comparatorArray?.length > 0) {
            picClassifications.push({
                "type": {
                    "coding": [
                        {
                            "code": "comparator",
                            "system": "https://fevir.net/resources/CodeSystem/179423",
                            "display": "Comparator"
                        }
                    ]
                },
                "classifier": comparativeEvidenceMap.picoClassifiers.comparatorArray
            });
        }
    }

    const [addTableRowModalState, setAddTableRowModalState] = useState({
        "newRowTitle": "",
        "newRowFocus": "",
        "newRowSections": []
    });
    const [newRowSectionsState, setNewRowSectionsState] = useState({});
    const [sourceReferencesState, setSourceReferencesState] = useState({
        outcomeDefinition: "", interventionOnlyEvidence: "", comparatorOnlyEvidence: "",
        comparativeEvidence: "", outcomeImportance: "", certaintyOfEvidence: ""
    });

    useEffect(() => {
        console.log("useEffect")
        if (newRowSectionsState.tableRowContentGenerated) {
            submitNewRowChange(addTableRowModalState, newRowSectionsState,
                dispatch, setOpenAddTableRowModalState);
            console.log("setTriggerReloadState to true due to change in newRowSectionState")
            setTriggerReloadState(true);
        }
    }, [newRowSectionsState]);

    useEffect((() => {
        console.log("useEffect")
        if (addTableRowModalState.newRowTitle) {
            setSourceReferencesState(prevState => {
                return {
                    ...prevState,
                    "outcomeDefinition": {
                        ...prevState.outcomeDefinition,
                        "display": addTableRowModalState.newRowTitle
                    }
                }
            });
        }
    }), [addTableRowModalState.newRowTitle]);

    useEffect(() => {
        console.log("useEffect")
        if (sourceReferencesState.outcomeDefinition) {
            let newRowFocus = JSON.parse(JSON.stringify(sourceReferencesState.outcomeDefinition))
            setAddTableRowModalState(prevState => { return { ...prevState, newRowFocus: newRowFocus } });
            let outcomeId = getIdFromReference(newRowFocus);
            if (outcomeId && !isNaN(outcomeId)) {
                if (outcomeDictionary[outcomeId]) {
                    let outcomeBody = {
                        id: outcomeId,
                        title: outcomeDictionary[outcomeId].title || outcomeDictionary[outcomeId].name,
                        shortTitle: outcomeDictionary[outcomeId].shortTitle || outcomeDictionary[outcomeId].title || outcomeDictionary[outcomeId].name,
                        fli: "",
                        resource: outcomeDictionary[outcomeId],
                        reference: newRowFocus
                    }
                    dispatch(outcomeVariableUpdated(outcomeBody));
                } else {
                    let outcomeResource = combinedDictionary[outcomeId];
                    if (outcomeResource) {
                        let outcomeBody = {
                            id: outcomeId,
                            title: outcomeResource.title || outcomeResource.name,
                            shortTitle: (outcomeResource.shortTitle || outcomeResource.title || outcomeResource.name)
                                .replace("OutcomeDefinition: ", "")
                                .replace("VariableDefinition: ", "")
                                .replace("DIO: ", "")
                                .replace("DichotomousIntendedOutcome: ", "")
                                .trim(),
                            fli: "",
                            resource: outcomeResource,
                            reference: newRowFocus
                        }
                        dispatch(outcomeVariableAdded(outcomeBody));
                    }
                }
            }
        }
    }, [sourceReferencesState.outcomeDefinition]);

    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
            className="formButton negative"
            content="✖"
            onClick={() => {
                setOpenAddTableRowModalState(prevState => { return { ...prevState, openModal: false }; });
            }} />
        <h3>Name the Outcome (how it will show in the table row header)</h3>
        <br />
        <StringEntry elementName='newRowTitle' fieldLabel='Title' required
            startingValue={addTableRowModalState.newRowTitle}
            setResourceState={setAddTableRowModalState} />
        <br />
        <h3>Set or create the structured Outcome Definition</h3>
        <br />
        <ReferenceEntry elementName='outcomeDefinition' enableCreation={true}
            containedResourceDictionary={containedResourceDictionary}
            fieldLabel='OutcomeDefinition (Resource Reference)'
            referencedResourceTypes={['EvidenceVariable']}
            shortTitle={addTableRowModalState.newRowTitle}
            startingResourceType="EvidenceVariable"
            selectProfile={["VariableDefinition", "DichotomousIntendedOutcome"]}
            addElementValues={{ title: addTableRowModalState.newRowTitle }}
            startingValue={sourceReferencesState.outcomeDefinition}
            setResourceState={setSourceReferencesState} />
        <br />
        <h3>Set or create the structured Comparator Only Evidence</h3>
        <br />
        <ReferenceEntry elementName='comparatorOnlyEvidence' enableCreation={true}
            containedResourceDictionary={containedResourceDictionary}
            fieldLabel='ComparatorOnlyEvidence (Resource Reference)'
            referencedResourceTypes={['Evidence']}
            startingResourceType="Evidence" setProfile="ComparatorOnlyEvidence"
            addElementValues={populationClassifications?.length > 0 ?
                {
                    title: "Control Evidence (Baseline Risk) for " + sourceReferencesState.outcomeDefinition?.display,
                    classification: populationClassifications,
                    variableDefinition: [
                        {
                            "description": "comparator only group",
                            "variableRole": "population"
                        },
                        {
                            "description": sourceReferencesState.outcomeDefinition?.display,
                            "variableRole": "outcome",
                            "observed": sourceReferencesState.outcomeDefinition
                        }
                    ]
                }
                :
                {
                    title: "Control Evidence (Baseline Risk) for " + sourceReferencesState.outcomeDefinition?.display,
                    variableDefinition: [
                        {
                            "description": "comparator only group",
                            "variableRole": "population"
                        },
                        {
                            "description": sourceReferencesState.outcomeDefinition?.display,
                            "variableRole": "outcome",
                            "observed": sourceReferencesState.outcomeDefinition
                        }
                    ]
                }
            }
            startingValue={sourceReferencesState.comparatorOnlyEvidence}
            setResourceState={setSourceReferencesState} />
        <br />
        <h3>Set or create the structured Intervention Only Evidence</h3>
        <br />
        <ReferenceEntry elementName='interventionOnlyEvidence' enableCreation={true}
            containedResourceDictionary={containedResourceDictionary}
            fieldLabel='InterventionOnlyEvidence (Resource Reference)'
            referencedResourceTypes={['Evidence']}
            startingResourceType="Evidence" setProfile="InterventionOnlyEvidence"
            addElementValues={{
                title: "Intervention Only Evidence for " + sourceReferencesState.outcomeDefinition?.display,
                variableDefinition: [
                    {
                        "description": "intervention only group",
                        "variableRole": "population"
                    },
                    {
                        "description": sourceReferencesState.outcomeDefinition?.display,
                        "variableRole": "outcome",
                        "observed": sourceReferencesState.outcomeDefinition
                    }
                ]
            }}
            startingValue={sourceReferencesState.interventionOnlyEvidence}
            setResourceState={setSourceReferencesState} />
        <br />
        <h3>Set or create the structured Comparative Evidence</h3>
        <br />
        <ReferenceEntry elementName='comparativeEvidence' enableCreation={true}
            containedResourceDictionary={containedResourceDictionary}
            fieldLabel='ComparativeEvidence (Resource Reference)'
            referencedResourceTypes={['Evidence']}
            startingResourceType="Evidence" setProfile="ComparativeEvidence"
            addElementValues={picClassifications?.length > 0 ?
                {
                    title: "Comparative Evidence for " + sourceReferencesState.outcomeDefinition?.display,
                    classification: picClassifications,
                    variableDefinition: [
                        {
                            "description": "total group",
                            "variableRole": "population"
                        },
                        {
                            "description": "intervention group vs. comparator group",
                            "variableRole": "exposure"
                        },
                        {
                            "description": sourceReferencesState.outcomeDefinition?.display,
                            "variableRole": "outcome",
                            "observed": sourceReferencesState.outcomeDefinition
                        }
                    ]
                }
                :
                {
                    title: "Comparative Evidence for " + sourceReferencesState.outcomeDefinition?.display,
                    variableDefinition: [
                        {
                            "description": "total group",
                            "variableRole": "population"
                        },
                        {
                            "description": "intervention group vs. comparator group",
                            "variableRole": "exposure"
                        },
                        {
                            "description": sourceReferencesState.outcomeDefinition?.display,
                            "variableRole": "outcome",
                            "observed": sourceReferencesState.outcomeDefinition
                        }
                    ]
                }
            }
            startingValue={sourceReferencesState.comparativeEvidence}
            setResourceState={setSourceReferencesState} />
        <br />
        <h3>Set or create the structured Certainty of Evidence</h3>
        <br />
        <ReferenceEntry elementName='certaintyOfEvidence' enableCreation={true}
            containedResourceDictionary={containedResourceDictionary}
            fieldLabel='CertaintyOfEvidence (Resource Reference)'
            referencedResourceTypes={['ArtifactAssessment']}
            startingResourceType="ArtifactAssessment" setProfile="CertaintyOfEvidence"
            addElementValues={{
                title: "Certainty of Evidence for " + sourceReferencesState.comparativeEvidence?.display,
                artifactReference: sourceReferencesState.comparativeEvidence
            }}
            startingValue={sourceReferencesState.certaintyOfEvidence}
            setResourceState={setSourceReferencesState} />
        <br />
        <br />
        {sourceReferencesState.comparativeEvidence?.reference &&
            <span>
                <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }}
                    className="formButton"
                    content="Generate Table Row" positive
                    onClick={() => {
                        generateNewTableRow(sourceReferencesState, setNewRowSectionsState,
                            compositionId, combinedDictionary, dispatch);
                    }}
                    disabled={!addTableRowModalState.newRowTitle}
                />
                &nbsp;&nbsp;
                {!addTableRowModalState.newRowTitle && <>Enter a title at the top to submit changes.</>}
            </span>}
        <br />
        <br />
    </div>;

    return (
        <Modal
            style={{ padding: "0px", margin: "0px", height: "96%" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={true}
            centered={false}
            content={modalContent}
        />
    )
};

const SoFEditTableCellModal = ({ targetFoi, item, itemIndex,
    setOpenEditModalState, setTriggerReloadState, findingsSectionIndex, containedResourceDictionary = {} }) => {
    //TODO - consider if outcomeVariableRefernece is changed, then the new 'targetFoi' also needs to get applied to row.focus
    const dispatch = useDispatch();
    const summaryOfFindings = useSelector(state => selectAllSummaryOfFindings(state));
    const baselineRiskEntry = useSelector(state => selectBaselineRiskById(state, targetFoi));
    const targetOutcome = useSelector(state => selectOutcomeVariableById(state, targetFoi));
    const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);
    const combinedDictionary = comparativeEvidenceMap.combinedDictionary;
    const compositionId = comparativeEvidenceMap.compositionId;
    const summaryOfFindingsSection = useSelector(state => selectSummaryOfFindingsByTargetId(state, targetFoi));
    const summaryOfFindingsSectionFromSlice = useSelector(state => selectTopSectionById(state, findingsSectionIndex));

    const [closeModalState, setCloseModalState] = useState(false);
    const [evidenceReferencesState, setEvidenceReferencesState] = useState({});
    const [cellDisplayState, setCellDisplayState] = useState({});
    const [initialCellDisplayState, setInitialCellDisplayState] = useState({});
    const [generatedNarrativeState, setGeneratedNarrativeState] = useState("");
    const [controlEvidenceResourceState, setControlEvidenceResourceState] = useState(null);
    const [initialControlEvidenceResourceState, setInitialControlEvidenceResourceState] = useState(null);
    const [interventionEvidenceResourceState, setInterventionEvidenceResourceState] = useState(null);
    const [initialInterventionEvidenceResourceState, setInitialInterventionEvidenceResourceState] = useState(null);
    const [comparativeEvidenceResourceState, setComparativeEvidenceResourceState] = useState(null);
    const [initialComparativeEvidenceResourceState, setInitialComparativeEvidenceResourceState] = useState(null);
    const [outcomeVariableResourceState, setOutcomeVariableResourceState] = useState(null);
    const [initialOutcomeVariableResourceState, setInitialOutcomeVariableResourceState] = useState(null);
    const [certaintyOfEvidenceResourceState, setCertaintyOfEvidenceResourceState] = useState(null);
    const [initialCertaintyOfEvidenceResourceState, setInitialCertaintyOfEvidenceResourceState] = useState(null);

    useEffect(() => {
        console.log("useEffect")
        let startingEvidenceReferencesState = {
            "controlEvidenceReference": "", "comparativeEvidenceReference": "",
            "interventionEvidenceReference": "", "certaintyOfEvidenceReference": "",
            "outcomeVariableReference": ""
        };
        if (item) {
            if (item.text) {
                setCellDisplayState({ "text": item.text });
                setInitialCellDisplayState({ "text": item.text });
            } else {
                setCellDisplayState({
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>"
                });
                setInitialCellDisplayState({
                    "status": "empty",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[No data.]</p></div>"
                });
            }
            if (item.entry?.length > 0) {
                let baselineRiskFoi;
                let comparativeEvidenceFoi;
                let interventionEvidenceFoi;
                let interventionEvidenceReference;
                let baselineRiskReference;
                let comparativeEvidenceReference;
                let certaintyOfEvidenceFoi;
                let certaintyOfEvidenceReference;
                let outcomeVariableFoi;
                let outcomeVariableReference;
                if (itemIndex === 0) {
                    outcomeVariableFoi = getIdFromReference(item.entry[0]);
                    outcomeVariableReference = item.entry[0];
                } else if (itemIndex === 2) {
                    baselineRiskFoi = getIdFromReference(item.entry[0]);
                    baselineRiskReference = item.entry[0];
                } else if (itemIndex === 3) {
                    interventionEvidenceFoi = getIdFromReference(item.entry[0]);
                    interventionEvidenceReference = item.entry[0];
                } else if (itemIndex === 5 || itemIndex === 1 || itemIndex === 7) {
                    comparativeEvidenceFoi = getIdFromReference(item.entry[0]);
                    comparativeEvidenceReference = item.entry[0];
                } else if (itemIndex === 4) {
                    baselineRiskFoi = getIdFromReference(item.entry[0]);
                    baselineRiskReference = item.entry[0];
                    if (item.entry[1]) {
                        comparativeEvidenceFoi = getIdFromReference(item.entry[1]);
                        comparativeEvidenceReference = item.entry[1];
                    }
                } else if (itemIndex === 6) {
                    if (item.entry?.[0]?.type === "ArtifactAssessment") {
                        certaintyOfEvidenceFoi = getIdFromReference(item.entry[0]);
                        certaintyOfEvidenceReference = item.entry[0];
                    } else if (item.entry?.[0]?.type === "Evidence") {
                        comparativeEvidenceFoi = getIdFromReference(item.entry[0]);
                        comparativeEvidenceReference = item.entry[0];
                    }
                }
                if (!outcomeVariableFoi) {
                    if (summaryOfFindingsSection.section[0].entry?.[0]) {
                        outcomeVariableFoi = getIdFromReference(summaryOfFindingsSection.section[0].entry[0]);
                        outcomeVariableReference = summaryOfFindingsSection.section[0].entry[0];
                    } else {
                        outcomeVariableFoi = targetFoi;
                    }
                }
                if (!baselineRiskFoi && summaryOfFindingsSection.section[2].entry?.[0]) {
                    baselineRiskFoi = getIdFromReference(summaryOfFindingsSection.section[2].entry[0]);
                    baselineRiskReference = summaryOfFindingsSection.section[2].entry[0];
                }
                if (!comparativeEvidenceFoi && summaryOfFindingsSection.section[5].entry?.[0]) {
                    comparativeEvidenceFoi = getIdFromReference(summaryOfFindingsSection.section[5].entry[0]);
                    comparativeEvidenceReference = summaryOfFindingsSection.section[5].entry[0];
                }
                if (baselineRiskReference) {
                    startingEvidenceReferencesState.controlEvidenceReference = baselineRiskReference;
                }
                if (comparativeEvidenceReference) {
                    startingEvidenceReferencesState.comparativeEvidenceReference = comparativeEvidenceReference;
                }
                if (interventionEvidenceReference) {
                    startingEvidenceReferencesState.interventionEvidenceReference = interventionEvidenceReference;
                }
                if (certaintyOfEvidenceReference) {
                    startingEvidenceReferencesState.certaintyOfEvidenceReference = certaintyOfEvidenceReference;
                }
                if (outcomeVariableReference) {
                    startingEvidenceReferencesState.outcomeVariableReference = outcomeVariableReference;
                }
                if (baselineRiskFoi && combinedDictionary[baselineRiskFoi]) {
                    setControlEvidenceResourceState(combinedDictionary[baselineRiskFoi]);
                    setInitialControlEvidenceResourceState(combinedDictionary[baselineRiskFoi]);
                } else if (baselineRiskFoi) {
                    setControlEvidenceResourceState({
                        "resourceType": "Evidence",
                        "id": baselineRiskFoi,
                        "statistic": []
                    });
                    setInitialControlEvidenceResourceState({
                        "resourceType": "Evidence",
                        "id": baselineRiskFoi,
                        "statistic": []
                    });
                }
                if (comparativeEvidenceFoi && combinedDictionary[comparativeEvidenceFoi]) {
                    setComparativeEvidenceResourceState(combinedDictionary[comparativeEvidenceFoi]);
                    setInitialComparativeEvidenceResourceState(combinedDictionary[comparativeEvidenceFoi]);
                } else if (comparativeEvidenceFoi) {
                    setComparativeEvidenceResourceState({
                        "resourceType": "Evidence",
                        "id": comparativeEvidenceFoi,
                        "statistic": []
                    });
                    setInitialComparativeEvidenceResourceState({
                        "resourceType": "Evidence",
                        "id": comparativeEvidenceFoi,
                        "statistic": []
                    });
                }
                if (interventionEvidenceFoi && combinedDictionary[interventionEvidenceFoi]) {
                    setInterventionEvidenceResourceState(combinedDictionary[interventionEvidenceFoi]);
                    setInitialInterventionEvidenceResourceState(combinedDictionary[interventionEvidenceFoi]);
                } else if (interventionEvidenceFoi) {
                    setInterventionEvidenceResourceState({
                        "resourceType": "Evidence",
                        "id": interventionEvidenceFoi,
                        "statistic": []
                    });
                    setInitialInterventionEvidenceResourceState({
                        "resourceType": "Evidence",
                        "id": interventionEvidenceFoi,
                        "statistic": []
                    });
                }
                if (certaintyOfEvidenceFoi && combinedDictionary[certaintyOfEvidenceFoi]) {
                    setCertaintyOfEvidenceResourceState(combinedDictionary[certaintyOfEvidenceFoi]);
                    setInitialCertaintyOfEvidenceResourceState(combinedDictionary[certaintyOfEvidenceFoi]);
                } else if (certaintyOfEvidenceFoi) {
                    setCertaintyOfEvidenceResourceState({
                        "resourceType": "ArtifactAssessment",
                        "id": certaintyOfEvidenceFoi,
                        "content": []
                    });
                    setInitialCertaintyOfEvidenceResourceState({
                        "resourceType": "ArtifactAssessment",
                        "id": certaintyOfEvidenceFoi,
                        "content": []
                    });
                }
                if (outcomeVariableFoi && combinedDictionary[outcomeVariableFoi]) {
                    setOutcomeVariableResourceState(combinedDictionary[outcomeVariableFoi]);
                    setInitialOutcomeVariableResourceState(combinedDictionary[outcomeVariableFoi]);
                } else if (outcomeVariableFoi) {
                    setOutcomeVariableResourceState({
                        "resourceType": "EvidenceVariable",
                        "id": outcomeVariableFoi
                    });
                    setInitialOutcomeVariableResourceState({
                        "resourceType": "EvidenceVariable",
                        "id": outcomeVariableFoi
                    });
                }

                let controlEventRate = NaN;
                let controlEventRateDisplay = "[Not a proportion.]";
                let controlEvidence;
                let comparativeEvidence;
                let cellDisplay = "";
                let observedInterventionEventRate = NaN;
                let observedInterventionEventRateDisplay = "[Not a proportion.]";
                let interventionEvidence;
                if (baselineRiskFoi && combinedDictionary[baselineRiskFoi]) {
                    controlEvidence = combinedDictionary[baselineRiskFoi];
                }
                if (comparativeEvidenceFoi && combinedDictionary[comparativeEvidenceFoi]) {
                    comparativeEvidence = combinedDictionary[comparativeEvidenceFoi];
                }
                let [returnA, returnB] = extractControlEventRate(controlEvidence, controlEventRate, controlEventRateDisplay);
                controlEventRate = returnA;
                controlEventRateDisplay = returnB;
                if (itemIndex === 2 && controlEvidence) {
                    cellDisplay = controlEventRateDisplay;
                }
                if (interventionEvidenceFoi && combinedDictionary[interventionEvidenceFoi]) {
                    interventionEvidence = combinedDictionary[interventionEvidenceFoi];
                }
                let [returnAi, returnBi] = extractControlEventRate(interventionEvidence, observedInterventionEventRate, observedInterventionEventRateDisplay);
                observedInterventionEventRate = returnAi;
                observedInterventionEventRateDisplay = returnBi;
                let riskDifference = NaN;
                let riskDifferenceDisplay = '[Not a difference in proportions.]';
                let interventionEventRate = NaN;
                let interventionEventRateDisplay = '[Not a proportion.]';
                let riskDifferenceLowValue = NaN;
                let riskDifferenceLowValueDisplay = 'No lower bound'
                let riskDifferenceHighValue = NaN;
                let riskDifferenceHighValueDisplay = 'No upper bound';
                let [riskDifferenceA, riskDifferenceDisplayA, interventionEventRateA, interventionEventRateDisplayA,
                    riskDifferenceLowValueA, riskDifferenceLowValueDisplayA, riskDifferenceHighValueA,
                    riskDifferenceHighValueDisplayA] = extractRiskDifferenceAndInterventionEventRate(controlEventRate,
                        riskDifference, riskDifferenceDisplay, interventionEventRate, interventionEventRateDisplay,
                        riskDifferenceLowValue, riskDifferenceLowValueDisplay, riskDifferenceHighValue,
                        riskDifferenceHighValueDisplay, comparativeEvidence, dispatch);
                riskDifference = riskDifferenceA;
                riskDifferenceDisplay = riskDifferenceDisplayA;
                interventionEventRate = interventionEventRateA;
                interventionEventRateDisplay = interventionEventRateDisplayA;
                riskDifferenceLowValue = riskDifferenceLowValueA;
                riskDifferenceLowValueDisplay = riskDifferenceLowValueDisplayA;
                riskDifferenceHighValue = riskDifferenceHighValueA;
                riskDifferenceHighValueDisplay = riskDifferenceHighValueDisplayA;
                if (itemIndex === 3 && interventionEvidence) {
                    cellDisplay = observedInterventionEventRateDisplay;
                }
                if (itemIndex === 4 && controlEvidence && comparativeEvidence) {
                    cellDisplay = interventionEventRateDisplay;
                };
                if (itemIndex === 5 && comparativeEvidence) {
                    cellDisplay = riskDifferenceDisplay;
                }
                if (itemIndex === 0 && outcomeVariableFoi && combinedDictionary[outcomeVariableFoi]) {
                    cellDisplay = combinedDictionary[outcomeVariableFoi].title.replace("OutcomeDefinition: ", "").trim();
                }
                if (itemIndex === 1 && comparativeEvidence) {
                    cellDisplay = "[No statistic found.]";
                    if (comparativeEvidence.statistic?.length > 0) {
                        for (const statistic of comparativeEvidence.statistic) {
                            let resultDisplayList = [];
                            if (statistic.sampleSize) {
                                if (statistic.sampleSize.numberOfStudies !== undefined && statistic.sampleSize.numberOfStudies !== "") {
                                    resultDisplayList.push(statistic.sampleSize.numberOfStudies + ' studies');
                                }
                                if (statistic.sampleSize.numberOfParticipants !== undefined && statistic.sampleSize.numberOfParticipants !== "") {
                                    resultDisplayList.push(statistic.sampleSize.numberOfParticipants + ' participants');
                                }
                                if (statistic.sampleSize.numberAnalyzed !== undefined && statistic.sampleSize.numberAnalyzed !== "") {
                                    resultDisplayList.push(statistic.sampleSize.numberAnalyzed + ' analyzed');
                                }
                                if (statistic.sampleSize.knownDataCount !== undefined && statistic.sampleSize.knownDataCount !== "") {
                                    resultDisplayList.push(statistic.sampleSize.knownDataCount + ' without missing data');
                                }
                            }
                            if ((statistic.numberAffected !== undefined && statistic.numberAffected !== "") || (statistic.numberOfEvents !== undefined && statistic.numberOfEvents !== "")) {
                                let abc = statistic.numberAffected !== undefined ? statistic.numberAffected : statistic.numberOfEvents;
                                resultDisplayList.push(abc + ' events');
                            }
                            if (resultDisplayList.length) {
                                cellDisplay = resultDisplayList.join(', ');
                                break;
                            } else {
                                cellDisplay = "[No sample size data.]";
                            }
                        }
                    }
                }
                if (itemIndex === 7 && comparativeEvidence) {
                    cellDisplay = comparativeEvidence.assertion || "[No assertion made.]";
                }
                if (itemIndex === 6) {
                    if (certaintyOfEvidenceFoi && combinedDictionary[certaintyOfEvidenceFoi]?.text?.div) {
                        cellDisplay = clearDivWrapper(combinedDictionary[certaintyOfEvidenceFoi].text.div);
                    } else if (comparativeEvidence?.certainty?.length > 0) {
                        if (comparativeEvidence.certainty[0]?.rating) {
                            cellDisplay = simpleDisplayStringFromFHIRCodeableConcept(comparativeEvidence.certainty[0].rating);
                        }
                        if (comparativeEvidence.certainty[0]?.description) {
                            if (cellDisplay) {
                                cellDisplay += " -- ";
                            }
                            cellDisplay += comparativeEvidence.certainty[0].description;
                        }
                    } else {
                        cellDisplay = "[Certainty not specified.]";
                    }
                }
                if (cellDisplay) {
                    setGeneratedNarrativeState({
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + cellDisplay + "</p></div>"
                    });
                }
            }
        }
        setEvidenceReferencesState(startingEvidenceReferencesState);
    }, [item]);

    useEffect((() => {
        console.log("useEffect")
        if (!jsonEquals(cellDisplayState.text, initialCellDisplayState.text)) {
            let newSoFSection = JSON.parse(JSON.stringify(summaryOfFindingsSection));
            newSoFSection.section[itemIndex].text = cellDisplayState.text;
            newSoFSection.itemChanged = true;
            dispatch(summaryOfFindingsUpdated(newSoFSection));
        }
    }), [cellDisplayState.text]);

    useEffect(() => {
        console.log("useEffect")
        if (evidenceReferencesState.controlEvidenceReference) {
            let baselineRiskFoi = getIdFromReference(evidenceReferencesState.controlEvidenceReference);
            if (baselineRiskFoi && combinedDictionary[baselineRiskFoi]) {
                setControlEvidenceResourceState(combinedDictionary[baselineRiskFoi]);
            } else {
                setControlEvidenceResourceState({
                    "resourceType": "Evidence",
                    "id": baselineRiskFoi,
                    "statistic": []
                });
            }
        }
        if (evidenceReferencesState.comparativeEvidenceReference) {
            let comparativeEvidenceFoi = getIdFromReference(evidenceReferencesState.comparativeEvidenceReference);
            if (comparativeEvidenceFoi && combinedDictionary[comparativeEvidenceFoi]) {
                setComparativeEvidenceResourceState(combinedDictionary[comparativeEvidenceFoi]);
            } else {
                setComparativeEvidenceResourceState({
                    "resourceType": "Evidence",
                    "id": comparativeEvidenceFoi,
                    "statistic": []
                });
            }
        }
        if (evidenceReferencesState.interventionEvidenceReference) {
            let interventionEvidenceFoi = getIdFromReference(evidenceReferencesState.interventionEvidenceReference);
            if (interventionEvidenceFoi && combinedDictionary[interventionEvidenceFoi]) {
                setInterventionEvidenceResourceState(combinedDictionary[interventionEvidenceFoi]);
            } else {
                setInterventionEvidenceResourceState({
                    "resourceType": "Evidence",
                    "id": interventionEvidenceFoi,
                    "statistic": []
                });
            }
        }
        if (evidenceReferencesState.certaintyOfEvidenceReference) {
            let certaintyOfEvidenceFoi = getIdFromReference(evidenceReferencesState.certaintyOfEvidenceReference);
            if (certaintyOfEvidenceFoi && combinedDictionary[certaintyOfEvidenceFoi]) {
                setCertaintyOfEvidenceResourceState(combinedDictionary[certaintyOfEvidenceFoi]);
            } else {
                setCertaintyOfEvidenceResourceState({
                    "resourceType": "ArtifactAssessment",
                    "id": certaintyOfEvidenceFoi,
                    "statistic": []
                });
            }
        }
        if (evidenceReferencesState.outcomeVariableReference) {
            let outcomeFoi = getIdFromReference(evidenceReferencesState.outcomeVariableReference);
            if (outcomeFoi && combinedDictionary[outcomeFoi]) {
                setOutcomeVariableResourceState(combinedDictionary[outcomeFoi]);
            } else {
                setOutcomeVariableResourceState({
                    "resourceType": "EvidenceVariable",
                    "id": outcomeFoi
                });
            }
        }
    }, [evidenceReferencesState.controlEvidenceReference,
    evidenceReferencesState.comparativeEvidenceReference,
    evidenceReferencesState.interventionEvidenceReference,
    evidenceReferencesState.certaintyOfEvidenceReference,
    evidenceReferencesState.outcomeVariableReference]);

    useEffect(() => {
        console.log("useEffect")
        if (controlEvidenceResourceState?.id && !jsonEquals(controlEvidenceResourceState, initialControlEvidenceResourceState)) {
            let controlEventRate = NaN;
            let controlEventRateDisplay = "[Not a proportion.]";
            let [returnA, returnB] = extractControlEventRate(controlEvidenceResourceState, controlEventRate, controlEventRateDisplay);
            controlEventRate = returnA;
            controlEventRateDisplay = returnB;
            let riskBody = {
                id: targetFoi,
                targetTitle: targetOutcome.title,
                baselineRiskFoi: controlEvidenceResourceState.id,
                fli: "",
                editPermission: true,
                controlEventRate: controlEventRate,
                controlEventRateDisplay: controlEventRateDisplay,
                resource: controlEvidenceResourceState,
                reference: evidenceReferencesState.controlEvidenceReference
            }
            if (!baselineRiskEntry || !baselineRiskEntry.id) {
                dispatch(baselineRiskAdded(riskBody));
            } else if (!jsonEquals(baselineRiskEntry.resource, controlEvidenceResourceState)) {
                dispatch(baselineRiskUpdated(riskBody));
            }
        }
        if (outcomeVariableResourceState?.id && !jsonEquals(outcomeVariableResourceState, initialOutcomeVariableResourceState)) {
            let outcomeBody = {
                id: outcomeVariableResourceState.id,
                title: outcomeVariableResourceState.title,
                shortTitle: outcomeVariableResourceState.shortTitle ||
                    outcomeVariableResourceState.title.replace("OutcomeDefinition: ", "")
                        .replace("VariableDefinition: ", "")
                        .replace("DIO: ", "")
                        .replace("DichotomousIntendedOutcome: ", "")
                        .trim(),
                fli: "",
                resource: outcomeVariableResourceState,
                reference: {
                    "reference": "EvidenceVariable/" + outcomeVariableResourceState.id,
                    "type": "EvidenceVariable",
                    "display": outcomeVariableResourceState.title
                }
            }
            if (!targetOutcome || !targetOutcome.id || targetOutcome.id !== outcomeVariableResourceState.id) {
                dispatch(outcomeVariableAdded(outcomeBody));
            } else if (!jsonEquals(targetOutcome.resource, outcomeVariableResourceState)) {
                dispatch(outcomeVariableUpdated(outcomeBody));
            }
        }
        if ((controlEvidenceResourceState &&
            Object.keys(controlEvidenceResourceState).length > 0 &&
            !jsonEquals(controlEvidenceResourceState, initialControlEvidenceResourceState))
            ||
            (comparativeEvidenceResourceState &&
                Object.keys(comparativeEvidenceResourceState).length > 0 &&
                !jsonEquals(comparativeEvidenceResourceState, initialComparativeEvidenceResourceState))
            ||
            (outcomeVariableResourceState &&
                Object.keys(outcomeVariableResourceState).length > 0 &&
                !jsonEquals(outcomeVariableResourceState, initialOutcomeVariableResourceState))
            ||
            (interventionEvidenceResourceState &&
                Object.keys(interventionEvidenceResourceState).length > 0 &&
                !jsonEquals(interventionEvidenceResourceState, initialInterventionEvidenceResourceState))
            ||
            (certaintyOfEvidenceResourceState &&
                Object.keys(certaintyOfEvidenceResourceState).length > 0 &&
                !jsonEquals(certaintyOfEvidenceResourceState, initialCertaintyOfEvidenceResourceState))) {
            recalculateSummaryOfFindingsFromResourceChanges(summaryOfFindingsSection,
                controlEvidenceResourceState,
                comparativeEvidenceResourceState, outcomeVariableResourceState,
                interventionEvidenceResourceState, certaintyOfEvidenceResourceState,
                itemIndex, dispatch, setGeneratedNarrativeState, compositionId,
                evidenceReferencesState);
        }
    }, [controlEvidenceResourceState, comparativeEvidenceResourceState, outcomeVariableResourceState,
        interventionEvidenceResourceState, certaintyOfEvidenceResourceState]);

    useEffect(() => {
        console.log("useEffect")
        if (closeModalState === true) {
            let findingsSection = summaryOfFindings.map(section => {
                let newSection = JSON.parse(JSON.stringify(section));
                delete newSection.id;
                delete newSection.itemChanged;
                return newSection;
            });
            if (!jsonEquals(summaryOfFindingsSectionFromSlice.revisedSection?.section, findingsSection)) {
                console.log("resourceUpdate for Composition.section[" + findingsSectionIndex + "].section");
                let newTopSectionDetail = JSON.parse(JSON.stringify(summaryOfFindingsSectionFromSlice));
                newTopSectionDetail.revisedSection.section = findingsSection;
                dispatch(topSectionUpdated(newTopSectionDetail));
            }
        }
    }, [closeModalState]);

    let modalContent = <div style={{
        paddingTop: "6px", paddingLeft: "20px", paddingRight: "20px",
        paddingBottom: "40px", width: "100%", height: "100%", overflow: "auto"
    }}>
        {(cellDisplayState && evidenceReferencesState) &&
            <>
                <Button style={{ padding: "6px", position: "absolute", right: "14px" }}
                    className="formButton negative"
                    content="✖"
                    onClick={() => {
                        setCloseModalState(true);
                        setOpenEditModalState(prevState => { return { ...prevState, openModal: false }; });
                        setTriggerReloadState(true);
                    }} />
                <h3>Edit Table Cell Content</h3>
                <br />
                {cellDisplayState.text &&
                    <NarrativeEntry elementName='text' fieldLabel='Narrative Summary'
                        generatedNarrative={generatedNarrativeState}
                        calledFrom={"SummaryOfFindingsTable"}
                        startingValue={cellDisplayState.text} setResourceState={setCellDisplayState} />
                }
                <br /><br />
                {(itemIndex === 0) &&
                    <>
                        <h3>Change Resource Reference for the Outcome Variable</h3>
                        <br />
                        <ReferenceEntry elementName='outcomeVariableReference'
                            containedResourceDictionary={containedResourceDictionary}
                            fieldLabel='VariableDefinition Reference' enableCreation={true}
                            startingResourceType={"EvidenceVariable"} startCollapsed={true}
                            referencedResourceTypes={["EvidenceVariable"]}
                            selectProfile={["VariableDefinition", "DichotomousIntendedOutcome"]}
                            startingValue={evidenceReferencesState.outcomeVariableReference}
                            setReferencedResourceState={setOutcomeVariableResourceState}
                            setResourceState={setEvidenceReferencesState} />
                        <br /><br />
                    </>}
                {(itemIndex === 2 || itemIndex === 4) &&
                    <>
                        <h3>Change Resource Reference for the Control Only Evidence (Baseline Risk)</h3>
                        <br />
                        <ReferenceEntry elementName='controlEvidenceReference'
                            containedResourceDictionary={containedResourceDictionary}
                            fieldLabel='ComparatorOnlyEvidence Reference' enableCreation={true}
                            startingResourceType={"Evidence"} referencedResourceTypes={["Evidence"]}
                            setProfile={"ComparatorOnlyEvidence"} startCollapsed={true}
                            startingValue={evidenceReferencesState.controlEvidenceReference}
                            setReferencedResourceState={setControlEvidenceResourceState}
                            setResourceState={setEvidenceReferencesState} />
                        <br /><br />
                    </>}
                {(itemIndex === 3) &&
                    <>
                        <h3>Change Resource Reference for the Intervention Only Evidence (Observed)</h3>
                        <br />
                        <ReferenceEntry elementName='interventionEvidenceReference'
                            containedResourceDictionary={containedResourceDictionary}
                            fieldLabel='InterventionOnlyEvidence Reference' enableCreation={true}
                            startingResourceType={"Evidence"} referencedResourceTypes={["Evidence"]}
                            setProfile={"InterventionOnlyEvidence"} startCollapsed={true}
                            startingValue={evidenceReferencesState.interventionEvidenceReference}
                            setReferencedResourceState={setInterventionEvidenceResourceState}
                            setResourceState={setEvidenceReferencesState} />
                        <br /><br />
                    </>}
                {(itemIndex === 1 || itemIndex === 5 || itemIndex === 4 || itemIndex === 6 || itemIndex === 7) &&
                    <>
                        <h3>Change Resource Reference for the Comparative Evidence</h3>
                        <br />
                        <ReferenceEntry elementName='comparativeEvidenceReference'
                            containedResourceDictionary={containedResourceDictionary}
                            fieldLabel='ComparativeEvidence Reference' enableCreation={true}
                            startingResourceType={"Evidence"} referencedResourceTypes={["Evidence"]}
                            setProfile={"ComparativeEvidence"} startCollapsed={true}
                            startingValue={evidenceReferencesState.comparativeEvidenceReference}
                            setReferencedResourceState={setComparativeEvidenceResourceState}
                            setResourceState={setEvidenceReferencesState} />
                        <br /><br />
                    </>}
                {(itemIndex === 6) &&
                    <>
                        <h3>Change Resource Reference for the Certainty of Evidence Rating</h3>
                        <br />
                        <ReferenceEntry elementName='certaintyOfEvidenceReference'
                            containedResourceDictionary={containedResourceDictionary}
                            fieldLabel='CertaintyOfEvidence Reference' enableCreation={true}
                            startingResourceType={"ArtifactAssessment"} referencedResourceTypes={["ArtifactAssessment"]}
                            setProfile={"CertaintyOfEvidence"} startCollapsed={true}
                            startingValue={evidenceReferencesState.certaintyOfEvidenceReference}
                            setReferencedResourceState={setCertaintyOfEvidenceResourceState}
                            setResourceState={setEvidenceReferencesState} />
                        <br /><br />
                    </>}
                <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }}
                    className="formButton"
                    content="Close Modal" positive
                    onClick={() => {
                        setCloseModalState(true);
                        setOpenEditModalState(prevState => { return { ...prevState, openModal: false }; });
                        setTriggerReloadState(true);
                    }}
                />
                <br />
            </>}
    </div>;

    return (
        <Modal
            style={{ padding: "0px", margin: "0px" }}
            dimmer={<Modal.Dimmer style={{ backgroundColor: "#00000077" }} />}
            open={true}
            centered={false}
            content={modalContent}
        />
    )
};

const loadParameterResources = async (dispatch, summaryOfFindings,
    apiToken, combinedDictionary, resourceCollection) => {
    dispatch(globalLoadingOn());
    let resourceDictionary = JSON.parse(JSON.stringify(combinedDictionary));
    for (const entry of resourceCollection) {
        resourceDictionary[entry.id] = entry.revisedResourceJson;
    }
    let targetResources = [];
    let fliListToProcess = [];
    targetResources = summaryOfFindings.map(section => {
        let targetfoi = section.focus?.reference?.replace("EvidenceVariable/", "");
        let targetfli;
        if (!targetfoi && section.focus?.identifier?.system === "https://fevir.net/FLI" && section.focus.identifier.value) {
            targetfli = section.focus.identifier.value;
        }
        let targettitle = section.focus?.display;
        if (!targetfoi && targetfli) {
            fliListToProcess.push(targetfli);
        }
        return {
            id: targetfoi,
            title: targettitle,
            fli: targetfli
        };
    });
    if (fliListToProcess.length > 0) {
        await addFoisFromFlisInTargetResources(targetResources, apiToken);
    }
    if (targetResources.length > 0) {
        let body = {
            findingsSection: summaryOfFindings,
            combinedDictionary: resourceDictionary,
            resourceCollection: resourceCollection
        };
        //Both of these cause the freeze on /resources/Composition/391926
        dispatch(fetchOutcomeVariables(body));
        dispatch(fetchBaselineRisk(body));
    }
    dispatch(globalLoadingOff());
};

//mutates findingsSection
const recalculateFindingsSectionFromReferences = (dispatch, findingsSection,
    combinedDictionary, baselineRiskResources) => {
    console.log("recalculateFindingsSectionFromReferences")
    const baselineRiskDictionary = {};
    for (let item of baselineRiskResources) {
        baselineRiskDictionary[item.id] = item;
    }
    for (let section of findingsSection) {
        let targetFoi = getIdFromReference(section.focus);
        if (targetFoi && (!isNaN(targetFoi))) {
            if (!section.section[0].text ||
                (section.section[0].text && section.section[0].text.status !== "additional")) {
                section.section[0].text = {
                    "status": "generated",
                    "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + (section.title || section.focus?.display) + "</p></div>"
                };
            }
            section.section[0].entry = [section.focus];
            let controlEventRate = NaN;
            let controlEventRateDisplay = "[Not a proportion.]";
            if (baselineRiskDictionary[targetFoi]?.resource) {
                let [returnA, returnB] = extractControlEventRate(baselineRiskDictionary[targetFoi].resource, controlEventRate, controlEventRateDisplay);
                controlEventRate = returnA;
                controlEventRateDisplay = returnB;
                if (!section.section[2].text ||
                    (section.section[2].text && section.section[2].text.status !== "additional")) {
                    section.section[2].text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + controlEventRateDisplay + "</p></div>"
                    };
                }
                section.section[2].entry = [baselineRiskDictionary[targetFoi].reference];
            }
            if (isNaN(controlEventRate) && section.section[2]?.entry?.[0]) {
                let baselineRiskFoi = getIdFromReference(section.section[2].entry[0]);
                let baselineRiskEvidence = combinedDictionary[baselineRiskFoi];
                controlEventRateDisplay = createSimpleEvidenceDisplay(baselineRiskEvidence) || "[Not a proportion.]";
                let [returnA, returnB] = extractControlEventRate(baselineRiskEvidence, controlEventRate, controlEventRateDisplay);
                controlEventRate = returnA;
                controlEventRateDisplay = returnB;
                if (!section.section[2].text ||
                    (section.section[2].text && section.section[2].text.status !== "additional")) {
                    section.section[2].text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + controlEventRateDisplay + "</p></div>"
                    };
                }
            }
            let observedInterventionEventRate = NaN;
            let observedInterventionEventRateDisplay = "[Not a proportion.]";
            if (section.section[3]?.entry?.[0]) {
                let interventionEvidenceFoi = getIdFromReference(section.section[3].entry[0]);
                let interventionRiskEvidence = combinedDictionary[interventionEvidenceFoi];
                observedInterventionEventRateDisplay = createSimpleEvidenceDisplay(interventionRiskEvidence) || "[Not a proportion.]";
                let [returnA, returnB] = extractControlEventRate(interventionRiskEvidence, observedInterventionEventRate, observedInterventionEventRateDisplay);
                observedInterventionEventRate = returnA;
                observedInterventionEventRateDisplay = returnB;
                if (!section.section[3].text ||
                    (section.section[3].text && section.section[3].text.status !== "additional")) {
                    section.section[3].text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + observedInterventionEventRateDisplay + "</p></div>"
                    };
                }
            }
            let riskDifference = NaN;
            let effectEstimateDisplay = '[Not a difference in proportions.]';
            let interventionEventRate = NaN;
            let interventionEventRateDisplay = '[Not a proportion.]';
            let riskDifferenceLowValue = NaN;
            let riskDifferenceLowValueDisplay = 'No lower bound';
            let riskDifferenceHighValue = NaN;
            let riskDifferenceHighValueDisplay = 'No upper bound';
            let comparativeEvidence;
            if (section.section[5]?.entry?.[0]) {
                let effectEstimateFoi = getIdFromReference(section.section[5].entry[0]);
                comparativeEvidence = combinedDictionary[effectEstimateFoi];
                effectEstimateDisplay = createSimpleEvidenceDisplay(comparativeEvidence) || '[Not a difference in proportions.]';
                let [riskDifferenceA, riskDifferenceDisplayA, interventionEventRateA, interventionEventRateDisplayA,
                    riskDifferenceLowValueA, riskDifferenceLowValueDisplayA, riskDifferenceHighValueA,
                    riskDifferenceHighValueDisplayA] = extractRiskDifferenceAndInterventionEventRate(controlEventRate,
                        riskDifference, effectEstimateDisplay, interventionEventRate, interventionEventRateDisplay,
                        riskDifferenceLowValue, riskDifferenceLowValueDisplay, riskDifferenceHighValue,
                        riskDifferenceHighValueDisplay, comparativeEvidence, dispatch);
                interventionEventRateDisplay = interventionEventRateDisplayA;
                if (!section.section[4].text ||
                    (section.section[4].text && section.section[4].text.status !== "additional")) {
                    section.section[4].text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + interventionEventRateDisplay + "</p></div>"
                    };
                }
                if (!section.section[5].text ||
                    (section.section[5].text && section.section[5].text.status !== "additional")) {
                    section.section[5].text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + effectEstimateDisplay + "</p></div>"
                    };
                }
                let sampleSizeDisplay = "[No statistic found.]";
                if (comparativeEvidence?.statistic?.length > 0) {
                    for (const statistic of comparativeEvidence.statistic) {
                        let resultDisplayList = [];
                        if (statistic.sampleSize) {
                            if (statistic.sampleSize.numberOfStudies !== undefined && statistic.sampleSize.numberOfStudies !== "") {
                                resultDisplayList.push(statistic.sampleSize.numberOfStudies + ' studies');
                            }
                            if (statistic.sampleSize.numberOfParticipants !== undefined && statistic.sampleSize.numberOfParticipants !== "") {
                                resultDisplayList.push(statistic.sampleSize.numberOfParticipants + ' participants');
                            }
                            if (statistic.sampleSize.numberAnalyzed !== undefined && statistic.sampleSize.numberAnalyzed !== "") {
                                resultDisplayList.push(statistic.sampleSize.numberAnalyzed + ' analyzed');
                            }
                            if (statistic.sampleSize.knownDataCount !== undefined && statistic.sampleSize.knownDataCount !== "") {
                                resultDisplayList.push(statistic.sampleSize.knownDataCount + ' without missing data');
                            }
                        }
                        if ((statistic.numberAffected !== undefined && statistic.numberAffected !== "") || (statistic.numberOfEvents !== undefined && statistic.numberOfEvents !== "")) {
                            let abc = statistic.numberAffected !== undefined ? statistic.numberAffected : statistic.numberOfEvents;
                            resultDisplayList.push(abc + ' events');
                        }
                        if (resultDisplayList.length) {
                            sampleSizeDisplay = resultDisplayList.join(', ');
                            break;
                        } else {
                            sampleSizeDisplay = "[No sample size data.]";
                        }
                    }
                }
                let certaintyDisplay = "";
                if (comparativeEvidence?.certainty?.[0]) {
                    if (comparativeEvidence.certainty[0].rating) {
                        certaintyDisplay = simpleDisplayStringFromFHIRCodeableConcept(comparativeEvidence.certainty[0].rating);
                    }
                    if (comparativeEvidence.certainty[0].description) {
                        if (certaintyDisplay) {
                            certaintyDisplay += " -- ";
                        }
                        certaintyDisplay += comparativeEvidence.certainty[0].description;
                    }
                }
                if (!certaintyDisplay) {
                    certaintyDisplay = "[Certainty not specified.]";
                }
                let assertionDisplay = comparativeEvidence?.assertion || "[No assertion made.]";
                if (!section.section[1].text ||
                    (section.section[1].text && section.section[1].text.status !== "additional")) {
                    section.section[1].text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + sampleSizeDisplay + "</p></div>"
                    };
                }
                if (!section.section[6].text ||
                    (section.section[6].text && section.section[6].text.status !== "additional")) {
                    section.section[6].text = {
                        "status": "generated",
                        "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certaintyDisplay + "</p></div>"
                    };
                }
                if (section.section[7]) {
                    if (!section.section[7].text ||
                        (section.section[7].text && section.section[7].text.status !== "additional")) {
                        section.section[7].text = {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + assertionDisplay + "</p></div>"
                        };
                    }
                }
            }
            if (section.section[6]?.entry?.[0] && section.section[6].entry[0].type === "ArtifactAssessment") {
                let certaintyOfEvidenceFoi = getIdFromReference(section.section[6].entry[0]);
                let certaintyOfEvidence = combinedDictionary[certaintyOfEvidenceFoi];
                if (certaintyOfEvidence?.text?.div) {
                    let certaintyDisplay = clearDivWrapper(certaintyOfEvidence.text.div);
                    if (!section.section[6].text ||
                        (section.section[6].text && section.section[6].text.status !== "additional")) {
                        section.section[6].text = {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>" + certaintyDisplay + "</p></div>"
                        };
                    }
                } else {
                    if (!section.section[6].text ||
                        (section.section[6].text && section.section[6].text.status !== "additional")) {
                        section.section[6].text = {
                            "status": "generated",
                            "div": "<div xmlns=\"http://www.w3.org/1999/xhtml\"><p>[Certainty not specified with Narrative.]</p></div>"
                        };
                    }
                }
            }
        }
    }
}

const reloadFindingsSection = (startingFindingsSectionState, summaryOfFindings,
    dispatch, setFindingsSectionChangedState, combinedDictionary,
    baselineRiskResources) => {
    let findingsSection = JSON.parse(JSON.stringify(summaryOfFindings));
    recalculateFindingsSectionFromReferences(dispatch, findingsSection,
        combinedDictionary, baselineRiskResources);
    if (findingsSection && !jsonEquals(startingFindingsSectionState, findingsSection)) {
        console.log("findingsSection is different so will be reloaded")
        dispatch(loadSummaryOfFindings({ summaryOfFindings: findingsSection }));
        setFindingsSectionChangedState(true);
    }
};

const SummaryOfFindingsTable = ({ findingsSectionIndex, columnHeadersSectionIndex, compositionResourceState,
    containedResourceDictionary = {}
}) => {

    const apiToken = useSelector(selectCurrentUserApiToken);
    const editMode = useSelector(state => selectEditMode(state));
    const dispatch = useDispatch();
    const resourceCollection = useSelector(state => selectAllResources(state));

    const outcomeVariablesStatus = useSelector(selectOutcomeVariablesStatus);
    const outcomeVariables = useSelector(state => selectAllOutcomeVariables(state));

    const comparativeEvidenceMap = useSelector(selectComparativeEvidenceMap);
    const summaryOfFindings = useSelector(state => selectAllSummaryOfFindings(state));
    const summaryOfFindingsStatus = useSelector(selectSummaryOfFindingsStatus);
    const baselineRiskStatus = useSelector(selectBaselineRiskStatus);
    const baselineRiskResources = useSelector(state => selectAllBaselineRisks(state));
    const summaryOfFindingsSectionFromSlice = useSelector(state => selectTopSectionById(state, findingsSectionIndex));
    const allTopSections = useSelector(selectAllTopSections);
    const topSectionsStatus = useSelector(selectTopSectionsStatus);
    const sections = allTopSections.map(entity => { return entity.revisedSection });

    const [startingFindingsSectionState, setStartingFindingsSectionState] = useState([]);
    const [columnHeadersState, setColumnHeadersState] = useState({});
    const [openEditModalState, setOpenEditModalState] = useState({ "openModal": false });
    const [openAddTableRowModalState, setOpenAddTableRowModalState] = useState({ "openModal": false });
    const [findingsSectionChangedState, setFindingsSectionChangedState] = useState(false);
    const [triggerReloadState, setTriggerReloadState] = useState(false);
    const [populationReferenceState, setPopulationReferenceState] = useState(null);

    useEffect(() => {
        console.log("useEffect")
        if (topSectionsStatus === "succeeded" && sections.length > 0 && findingsSectionIndex !== null) {
            if (summaryOfFindingsStatus === "idle") {
                let findingsSection;
                if (sections[findingsSectionIndex] &&
                    sections[findingsSectionIndex].code?.coding?.[0]?.code === "summary-of-findings" &&
                    sections[findingsSectionIndex].section.length > 0) {
                    findingsSection = JSON.parse(JSON.stringify(sections[findingsSectionIndex].section));
                    let summaryOfFindingsArray = findingsSection.map(section => {
                        let targetFoi = getIdFromReference(section.focus);
                        section.id = targetFoi;
                        section.itemChanged = false;
                        return section;
                    });
                    let summaryOfFindingsBody = { summaryOfFindings: summaryOfFindingsArray };
                    dispatch(loadSummaryOfFindings(summaryOfFindingsBody));
                }
            }
            if (summaryOfFindingsStatus === "succeeded") {
                setStartingFindingsSectionState(JSON.parse(JSON.stringify(summaryOfFindings)));
            }
            let columnHeadersSection;
            if (sections[columnHeadersSectionIndex] &&
                sections[columnHeadersSectionIndex]?.code?.coding?.[0]?.code === "column-headers" &&
                sections[columnHeadersSectionIndex].section.length > 0
            ) {
                columnHeadersSection = JSON.parse(JSON.stringify(sections[columnHeadersSectionIndex]));
                let columnHeaders = columnHeadersSection.section.map(item => {
                    let label = clearDivWrapper(item?.text?.div);
                    return label;
                });
                setColumnHeadersState(columnHeaders);
            }
        }
    }, [topSectionsStatus, summaryOfFindingsStatus, findingsSectionIndex, sections[columnHeadersSectionIndex]]);

    useEffect(() => {
        console.log("useEffect")
        if (summaryOfFindingsStatus === "idle") {
            //
        } else if (editMode === true) {
            if (baselineRiskStatus === "idle" || outcomeVariablesStatus === "idle"
                //    baselineRiskStatus === "failed" || outcomeVariablesStatus === "failed"
            ) {
                loadParameterResources(dispatch, summaryOfFindings,
                    apiToken, comparativeEvidenceMap.combinedDictionary, resourceCollection);
            }
            if (baselineRiskStatus === "succeeded" && outcomeVariablesStatus === "succeeded" &&
                summaryOfFindings && resourceCollection?.length > 0) {
                let resourceDictionary = JSON.parse(JSON.stringify(comparativeEvidenceMap.combinedDictionary));
                for (const entry of resourceCollection) {
                    resourceDictionary[entry.id] = entry.revisedResourceJson;
                }
                reloadFindingsSection(startingFindingsSectionState, summaryOfFindings,
                    dispatch, setFindingsSectionChangedState, resourceDictionary,
                    baselineRiskResources);
            }
        }
    }, [baselineRiskStatus, outcomeVariablesStatus, editMode, summaryOfFindingsStatus]); //The baselineRiskStatus, outcomeVariablesStatus here triggers infinite loop from loadParameterResources inside

    useEffect(() => {
        console.log("useEffect")
        if (triggerReloadState === true) {
            let resourceDictionary = JSON.parse(JSON.stringify(comparativeEvidenceMap.combinedDictionary));
            for (const entry of resourceCollection) {
                resourceDictionary[entry.id] = entry.revisedResourceJson;
            }
            reloadFindingsSection(startingFindingsSectionState, summaryOfFindings,
                dispatch, setFindingsSectionChangedState, resourceDictionary,
                baselineRiskResources);
            setTriggerReloadState(false);
        }
    }, [triggerReloadState]);

    useEffect(() => {
        console.log("useEffect")
        if (findingsSectionChangedState === true) {
            let findingsSection = summaryOfFindings.map(section => {
                let newSection = JSON.parse(JSON.stringify(section));
                delete newSection.id;
                delete newSection.itemChanged;
                return newSection;
            });
            if (!jsonEquals(summaryOfFindingsSectionFromSlice.revisedSection?.section, findingsSection)) {
                console.log("resourceUpdate for Composition.section[" + findingsSectionIndex + "].section");
                let newTopSectionDetail = JSON.parse(JSON.stringify(summaryOfFindingsSectionFromSlice));
                newTopSectionDetail.revisedSection.section = findingsSection;
                dispatch(topSectionUpdated(newTopSectionDetail));
            }
        }
    }, [findingsSectionChangedState]);

    useEffect(() => {
        console.log("useEffect")
        if (compositionResourceState.subject?.length > 0) {
            let populationReference = compositionResourceState.subject[0];
            setPopulationReferenceState(populationReference);
        }
    }, [compositionResourceState.subject]);

    return <div>
        {(summaryOfFindingsStatus === "succeeded") &&
            <>
                {editMode &&
                    <>
                        {(outcomeVariables && Object.keys(outcomeVariables).length > 0) ?
                            <>{populationReferenceState &&
                                <ChangeBaselineRiskEstimates setTriggerReloadState={setTriggerReloadState}
                                    populationDescription={populationReferenceState.display || "Unnamed population"}
                                    populationReference={populationReferenceState} />}
                                <p></p>
                                <GenerateNetEffectReport summaryOfFindingsJson={compositionResourceState}
                                    resourceDictionary={comparativeEvidenceMap.combinedDictionary} />
                            </>
                            :
                            <>
                                <span onClick={() => {
                                    loadParameterResources(dispatch, summaryOfFindings,
                                        apiToken, comparativeEvidenceMap.combinedDictionary, resourceCollection);
                                }}>Reload Source JSON</span>
                            </>
                        }
                        <br />
                        <br />
                    </>}
                {openEditModalState.openModal &&
                    <SoFEditTableCellModal
                        targetFoi={openEditModalState.targetFoi}
                        item={openEditModalState.item}
                        itemIndex={openEditModalState.itemIndex}
                        containedResourceDictionary={containedResourceDictionary}
                        setOpenEditModalState={setOpenEditModalState}
                        setTriggerReloadState={setTriggerReloadState}
                        findingsSectionIndex={findingsSectionIndex}
                    />}
                {openAddTableRowModalState.openModal &&
                    <AddTableRowModal
                        setOpenAddTableRowModalState={setOpenAddTableRowModalState}
                        containedResourceDictionary={containedResourceDictionary}
                        setTriggerReloadState={setTriggerReloadState} />}
                <Table>
                    <Table.Header>
                        <Table.Row>
                            {columnHeadersState?.length > 0 && columnHeadersState.map((label, labelIndex) => {
                                return <Table.HeaderCell key={labelIndex}>
                                    <DisplayFromFHIRXhtml xhtml={label} />
                                </Table.HeaderCell>
                            })}
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {summaryOfFindings.map((row, rowIndex) => {
                            return <Table.Row key={rowIndex}>
                                {row.section.map((item, itemIndex) => {
                                    return <Table.Cell key={itemIndex}>
                                        {(editMode && itemIndex !== 8) &&
                                            <>
                                                <span className={"unselectable"}
                                                    style={{ cursor: "pointer" }}
                                                    onClick={() => {
                                                        setOpenEditModalState({
                                                            openModal: true,
                                                            targetFoi: getIdFromReference(row.focus),
                                                            item: item, itemIndex: itemIndex, entryIndex: rowIndex
                                                        });
                                                    }}>✎ Edit</span>
                                                <br />
                                                <br />
                                            </>}
                                        <span>
                                            {item?.text?.div &&
                                                <DisplayFromFHIRXhtml xhtml={item.text.div} />
                                            }
                                        </span>
                                        {(editMode && itemIndex === 0) &&
                                            <div>
                                                <br />
                                                <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }}
                                                    className="formButton"
                                                    positive
                                                    content={"Regenerate Table Row"}
                                                    onClick={() => {
                                                        regenerateTableRow(row,
                                                            comparativeEvidenceMap.combinedDictionary,
                                                            dispatch);
                                                        setTriggerReloadState(true);
                                                    }}
                                                />
                                            </div>
                                        }
                                    </Table.Cell>
                                })
                                }</Table.Row>
                        })}
                    </Table.Body>
                </Table>
                {editMode &&
                    <>
                        <Button style={{ color: "#FFFFFF", width: "230px", float: "left" }}
                            className="formButton"
                            content="+ Add Table Row" positive
                            onClick={() => {
                                setOpenAddTableRowModalState({ openModal: true });
                            }}
                        />
                        <br /><br />
                    </>}
            </>}
    </div>
}

export default SummaryOfFindingsTable;
export { SoFEditTableCellModal };